const config = {
  
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',

  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,

  discordLink:  'https://discord.gg/e3xtBsYgpc',
  
  layout: {
    leftSidebar: {
      desktopWidth: '400px',
      desktopMaxWidth: '550px',
      mobileWidth: '80%',
    },
    rightSidebar: {
      desktopWidth: '400px',
      desktopMaxWidth: '550px',
      mobileWidth: '80%',
    }
  }
};

export default config;